// 构建入口类型
export enum AppEntryType {
    PC_EDIT = 'pc_edit',                // pc编辑器
    MOBILE_EDIT = 'mobile_edit',        // 移动端编辑器
    MEETING_ROOM = 'meeting_room',      // 演示房间层
    PPT_PLAYER = 'ppt_player',          // ppt演示播放器，给一些内嵌场景用的
    CONTENT_VIEWER_SDK = 'content_viewer_sdk',  // 内容查看器SDK
}

export interface IInfrastructureBase {
    /**
     * slide 初始化时间戳
     */
    initDatetime: Date;
    // 初始化
    init(): void;

    // 获取入口类型
    getEntryType(): AppEntryType;
}
